import React, { useEffect, useState } from 'react';
import { usePrevious, useDebounce, useUnmount } from 'react-use';
import store from '../redux/store';
import config from '../config';
import languages from '../constants/DefaultLang';
import { getPages, resetPages } from '../redux/modules/generalPage/action';
import setEnableTealiumStatus from '../redux/modules/enableTealium/action';
import setEnableAdGlareStatus from '../redux/modules/enableAdGlare/action';

const consoleColor = {
  style1: 'color: #bada55;',
  'style1.1': 'color: #bada55; font-weight: bold; font-size: 30px;',
  style2: 'color: #fb5004;',
  'style2.1': 'color: #fb5004; font-weight: bold; font-size: 30px;',
  style3: 'color: #ca8d20;',
  'style3.1': 'color: #ca8d20; font-weight: bold; font-size: 30px;',
};

const useNotFound = (page) => {
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    setNotFound(page.error);
  }, [page.error]);
  return notFound;
};

const useDelayJsLoadiing = (page) => {
  const prevPageLoading = usePrevious(page.isLoading);
  const cmsPageApiLoaded =
    prevPageLoading === true && page.isLoading === false && page.error === false;

  const { data = {} } = page || {};
  const content = ((data || {}).content || {}).content || {};
  const { js_script_block = '', extra_head = '' } = content;
  const [jsLoading, setJsLoading] = React.useState(false);

  useEffect(() => {
    if (cmsPageApiLoaded) {
      if (js_script_block || extra_head) {
        setJsLoading(true);
        setTimeout(() => {
          setJsLoading(false);
          console.log('setJsLoading false');
        }, 1000);
      }
    }
  }, [cmsPageApiLoaded]);

  return jsLoading;
};

const useDebounceLoading = (page) => {
  const [debounceLoading, setDebounceLoading] = React.useState(true);
  useDebounce(
    () => {
      setDebounceLoading(page.isLoading);
    },
    config.debounceFetchTimeMS,
    [page.isLoading],
  );
  return debounceLoading;
};

const useTealium = (locale, siteConfig, page, isAllowCookies, isEnableTealium, domTitle) => {
  const siteConfigData = siteConfig.data || {};
  const { fairYear = '' } = siteConfigData;
  const { data = {} } = page || {};
  const content = ((data || {}).content || {}).content || {};
  const { mtConfig = {} } = content;
  const { tealium_subsection = '', tealium_pagename = '' } = mtConfig;

  const [localeReady, setLocaleReady] = useState(false);
  const [domTitleReady, setDomTitleReady] = useState(false);

  const fireTealiumAction = () => {
    const tealiumSubsection = (tealium_subsection || config.tealium.subsection).toUpperCase();
    const fairYearObj = fairYear !== '' && { fair_year: fairYear };
    const pageNameObj = tealium_pagename !== '' && { page_name: tealium_pagename };
    const defaultObj = {
      site_subsection: tealiumSubsection,
      page_type:
        tealium_subsection.toLowerCase() === config.tealiumHome.pageType
          ? config.tealiumHome.pageType
          : config.tealium.pageType,
    };

    window.utag.view(Object.assign(defaultObj, fairYearObj, pageNameObj));

    console.log(tealiumSubsection, fairYearObj, pageNameObj);

    setDomTitleReady(false);
    console.log('====================================');
    console.log('setDomTitleReady false');
    console.log('====================================');

    setLocaleReady(false);
    console.log('====================================');
    console.log('setLocaleReady false');
    console.log('====================================');
  };

  const fireTealium = () => {
    if (window.utag) {
      fireTealiumAction();
    } else {
      console.log('====================================');
      console.log('window utag not ready');
      console.log('====================================');

      let tryCount = 0;
      const waitTealiumLibraryInit = setInterval(() => {
        console.log('waitTealiumLibraryInit.....');
        tryCount++;
        if (window.utag) {
          fireTealiumAction();
          tryCount = 0;
          clearInterval(waitTealiumLibraryInit);
        }
        if (tryCount > config.interval.times) {
          console.log(`TealiumLibrary init Fail within ${config.interval.times} try`);
          tryCount = 0;
          clearInterval(waitTealiumLibraryInit);
        }
      }, config.interval.frequency);
    }
  };

  const fireWebTrends = () => {
    if (window.sendWebTrendsData) {
      window.sendWebTrendsData();
    } else {
      let tryCount = 0;
      const waitWebTrendsLibraryInit = setInterval(() => {
        console.log('waitWebTrendsLibraryInit.....');
        tryCount++;
        if (window.sendWebTrendsData) {
          window.sendWebTrendsData();
          tryCount = 0;
          clearInterval(waitWebTrendsLibraryInit);
        }
        if (tryCount > config.interval.times) {
          console.log(`WebTrendsLibrary init Fail within ${config.interval.times} try`);
          tryCount = 0;
          clearInterval(waitWebTrendsLibraryInit);
        }
      }, config.interval.frequency);
    }
  };

  // const prevDomTitle = usePrevious(domTitle);
  useEffect(() => {
    if (domTitle) {
      setDomTitleReady(true);
      console.log('====================================');
      // console.log(domTitle, prevDomTitle);
      console.log('setDomTitleReady true');
      console.log('====================================');
    }
  }, [domTitle]);

  useEffect(() => {
    if (isAllowCookies && process.env.REACT_APP_TEALIUM_ENABLE === 'true' && !isEnableTealium) {
      console.log('%cTrigger setEnableTealiumStatus', `${consoleColor.style1}`);
      store.dispatch(setEnableTealiumStatus(true));
    }
  }, [isAllowCookies]);

  const prevPageLoading = usePrevious(page.isLoading);
  const cmsPageApiLoaded =
    prevPageLoading === true && page.isLoading === false && page.error === false;
  const [readyTriggerTealium, setReadyTriggerTealium] = useState(false);
  const [readyTriggerWebTrends, setReadyTriggerWebTrends] = useState(false);

  useEffect(() => {
    console.log('Set CMS Page API Ready to true');
    if (cmsPageApiLoaded) {
      setReadyTriggerTealium(true);
      // console.log('Change readyTriggerTealium true');

      setReadyTriggerWebTrends(true);
      // console.log('Change readyTriggerWebTrends true');
    } // else it's triggered by true->false
  }, [cmsPageApiLoaded, domTitleReady]);

  useEffect(() => {
    // console.log('%c***********************************************', `${consoleColor.style1}`);
    // console.log(`%cprevPageLoading: ${prevPageLoading}`, `${consoleColor.style1}`);
    // console.log(`%ccmsPageApiLoaded: ${cmsPageApiLoaded}`, `${consoleColor.style1}`);
    // console.log(`%cisEnableTealium: ${isEnableTealium}`, `${consoleColor.style1}`);
    // console.log(`%creadyTriggerTealium: ${readyTriggerTealium}`, `${consoleColor.style1}`);
    // console.log('%c***********************************************', `${consoleColor.style1}`);

    if (domTitleReady) {
      if (readyTriggerTealium && isEnableTealium) {
        // isEnableTealium: ensure cookie ready
        console.log('%cTrigger Tealium', `${consoleColor['style1.1']}`);
        fireTealium();
        setReadyTriggerTealium(false);
      }

      if (readyTriggerWebTrends) {
        console.log('%cTrigger WebTrendsData', `${consoleColor['style3.1']}`);
        fireWebTrends();
        setReadyTriggerWebTrends(false);
      }
    }
  }, [readyTriggerTealium, isEnableTealium, readyTriggerWebTrends, domTitleReady]);

  const prevLocal = usePrevious(locale);
  useEffect(() => {
    if (prevLocal) {
      setLocaleReady(true);
      // console.log('====================================');
      // console.log('LocaleReady true', localeReady);
      // console.log('====================================');

      const prevLocaleTitle = content[prevLocal].seo.seo_title;
      const currentLocaleTitle = content[locale].seo.seo_title;

      console.log(prevLocaleTitle, currentLocaleTitle);
      if (prevLocaleTitle === currentLocaleTitle) {
        setDomTitleReady(true);
      }
    }
  }, [locale]);

  useEffect(() => {
    // console.log('====================================');
    // console.log('domTitleReady change', domTitleReady);
    // console.log('====================================');

    if (localeReady && domTitleReady) {
      console.log('%cTrigger WebTrendsData local', `${consoleColor['style3.1']}`);
      fireWebTrends();

      if (isEnableTealium) {
        console.log('%cTrigger Tealium local', `${consoleColor['style1.1']}`);
        fireTealium();
      }
    }
  }, [localeReady, domTitleReady]);
};

const usePage = (pageName = 'default', pageType = 'Page/Static Page') => {
  const prevPageName = usePrevious(pageName);
  useEffect(() => {
    if (prevPageName) {
      store.dispatch(resetPages());
    }
    store.dispatch(getPages(pageName, pageType));
  }, [pageName]);
};

const useUnmountResetPage = () => {
  useUnmount(() => {
    store.dispatch(resetPages());
  });
};

const initAdGlare = (lang, adGlareID) => {
  (function (r, d, u) {
    const s = d.createElement(r);
    s.async = true;
    s.setAttribute('data-cfasync', false);
    u += `&cb=${Date.now()}${Math.random()}`;
    s.src = u;
    const n = d.getElementsByTagName(r)[0];
    n.parentNode.insertBefore(s, n);
  })('script', document, `//a-engine.hktdc.com/?${adGlareID}&keywords=${languages[lang].adGlare}`);

  setTimeout(() => {
    console.log(window.AdGlare);
    window.AdGlare && store.dispatch(setEnableAdGlareStatus(true));
  }, 300);
};

const useAdGlare = (locale, siteConfig, page, isEnableAdGlare) => {
  const siteConfigData = siteConfig.data || {};
  const { adGlare_id } = siteConfigData;

  const prevPageLoading = usePrevious(page.isLoading);
  const cmsPageApiLoaded =
    prevPageLoading === true && page.isLoading === false && page.error === false;

  const prevSiteConfigLoading = usePrevious(siteConfig.isLoading);
  const cmsSiteConfigApiLoaded =
    prevSiteConfigLoading === true && siteConfig.isLoading === false && siteConfig.error === false;
  const [readyTriggerAdGlare, setReadyTriggerAdGlare] = useState(false);

  useEffect(() => {
    console.log('Set CMS Page API Ready to true');
    if (cmsPageApiLoaded) {
      setReadyTriggerAdGlare(true);
    } // else it's triggered by true->false
  }, [cmsPageApiLoaded]);

  const prevLocale = usePrevious(locale);
  useEffect(() => {
    // console.log('%====================================', `${consoleColor.style2}`);
    // console.log(`%cprevPageLoading: ${prevPageLoading}`, `${consoleColor.style2}`);
    // console.log(`%ccmsPageApiLoaded: ${cmsPageApiLoaded}`, `${consoleColor.style2}`);
    // console.log(`%ccmsSiteConfigApiLoaded: ${cmsSiteConfigApiLoaded}`, `${consoleColor.style2}`);
    // console.log(`%creadyTriggerAdGlare: ${readyTriggerAdGlare}`, `${consoleColor.style2}`);
    // console.log(`%cprevLocale: ${prevLocale}`, `${consoleColor.style2}`);
    // console.log(`%clocale: ${locale}`, `${consoleColor.style2}`);
    // console.log(`%cadGlare_id: ${adGlare_id}`, `${consoleColor.style2}`);
    // console.log('%====================================', `${consoleColor.style2}`);

    if (!locale) return;

    // useEffect triggered by cmsSiteConfigApiLoaded and cmsSiteConfigApiLoaded
    if (readyTriggerAdGlare && adGlare_id) {
      // Triggered by page change
      // adGlare_id would be ready after cmsSiteConfigApiLoaded
      if (!isEnableAdGlare) {
        console.log('%cTrigger AdGlare init', `${consoleColor['style2.1']}`);
        initAdGlare(locale, adGlare_id);
      } else {
        console.log('%cTrigger AdGlare refresh', `${consoleColor['style2.1']}`);
        window.AdGlare.API.Refresh(adGlare_id);
      }
      setReadyTriggerAdGlare(false); // restore the state for next page change
    } else if (isEnableAdGlare && prevLocale && locale !== prevLocale) {
      // WORKAROUND: prevLocale is undefinded when the page is changed.
      // Triggered by locale change
      console.log('%cTrigger AdGlare locale change', `${consoleColor['style2.1']}`);
      window.AdGlare.API.Refresh(adGlare_id, { keywords: languages[locale].adGlare });
    } // else AdGlare is not ready to be loaded / refreshed

    // todo: cmsPageApiLoaded may change to readyTriggerAdGlare
  }, [locale, cmsPageApiLoaded, cmsSiteConfigApiLoaded]);
};

export {
  useNotFound,
  useDebounceLoading,
  useDelayJsLoadiing,
  usePage,
  useTealium,
  useUnmountResetPage,
  useAdGlare,
};
